/**
 * Přepíná panely řad v popupu s výsledky testů SGS.
 * Bez JavaScriptu zůstane viditelný panel řady zvolené v šabloně,
 * což je ten, který na dané produktové stránce dává smysl.
 */
class LabCertification extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector('[data-lab-cert-select]');
    if (!this.select) return;
    this.select.addEventListener('change', this.onChange.bind(this));
  }

  onChange(event) {
    const value = event.target.value;
    this.querySelectorAll('[data-lab-cert-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.labCertPanel !== value;
    });
  }
}

if (!customElements.get('lab-certification')) {
  customElements.define('lab-certification', LabCertification);
}
